export class BltUiTextConstant {
    static readonly BLT_UI_TEXT_JHA_FORM: string = "JHA-FORM";
}